import React from 'react';
import PropTypes from 'prop-types';

import styles from './StatusBadge.module.scss';

const StatusBadge = ({ status, className }) => {
  const isClosed = status === 'expired' || status === 'inactive';

  let badgeClass = styles.statusBadge;
  let displayText = status;

  if (isClosed) {
    badgeClass = `${styles.statusBadge} ${styles.statusClosed}`;
    displayText = 'closed';
  } else if (status === 'pending_approval') {
    badgeClass = `${styles.statusBadge} ${styles.statusPending}`;
    displayText = 'pending';
  } else if (status === 'active') {
    badgeClass = `${styles.statusBadge} ${styles.statusActive}`;
    displayText = 'active';
  } else if (status === 'open') {
    badgeClass = `${styles.statusBadge} ${styles.statusOpen}`;
    displayText = 'open';
  }

  const combinedClassName = className
    ? `${badgeClass} ${className}`
    : badgeClass;

  return (
    <span className={combinedClassName}>{displayText.replace('_', ' ')}</span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StatusBadge;
